var lib_core      = require("lib-core");
var lib_geometry      = require("lib-geometry");
var THREE         = require("three");
var GUIHandleModel  = require("./guiHandleModel.js");

var PositionHandleModel = function (editorModel, handleId) {
    GUIHandleModel.call(this, editorModel, handleId);

    this.multipleSubjects = false;// todo multiple subjects

    this.startPosition = null;
    this.contactOffset = null;
    this.snapped = this.value("snapped", true);
    this.selected = this.value("selected", true);
};

lib_core.inherit(PositionHandleModel, GUIHandleModel);
PositionHandleModel.$class = "PositionHandleModel";
module.exports = PositionHandleModel;

PositionHandleModel.prototype.getSubject = function(){
    return this.subjects.getOne(); // todo
} 

PositionHandleModel.prototype.getSubjectsRadius = function(){
    return this.getSubject().getRadius();
} 

PositionHandleModel.prototype.getSubjectsCenter = function(){
    return this.getSubject().getPosition();
} 

PositionHandleModel.prototype.getSubjectsRotation = function(){
    return new lib_geometry.Coord3d();
} 


PositionHandleModel.prototype.createMovementPlane = function(ray, point){}

PositionHandleModel.prototype.setContactPosition = function(position){}

PositionHandleModel.prototype.setMousePosition = function(position){}

PositionHandleModel.prototype.released = function(){}